import styled from 'styled-components';

const Subtitle = styled.div`
    display: flex;
    margin-bottom: 8px;
    ${({ profile }) => profile ? 'min-width: 50%' : ''}
`

export default Subtitle;


// WEBPACK FOOTER //
// ./src/UserInfo/dev/Subtitle.js